import { skipToken, UseQueryResult, useQuery } from '@tanstack/react-query'

import { getChainConfigEntry } from '@/config/chain'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { MarketRateChartData } from '@/features/sparklend/market-details/data/market-charts/types'

export interface UseBorrowRateHistoricParams {
  chainId: number
  symbol: TokenSymbol
}

export function useBorrowRateHistoric({
  chainId,
  symbol,
}: UseBorrowRateHistoricParams): UseQueryResult<MarketRateChartData> {
  const borrowRateQueryOptions = getChainConfigEntry(chainId).sparkLend?.borrowRateQueryOptions

  return useQuery(
    borrowRateQueryOptions
      ? borrowRateQueryOptions(symbol)
      : {
          queryKey: ['unsupported-borrow-rate-query'],
          queryFn: skipToken,
        },
  )
}
